import React from 'react';
import { graphql } from 'gatsby';
import marked from 'marked';

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import BaseLayout from '../../layouts/base-layout';
import HeadWrapper from '../../components/layout/head-wrapper';
import Modal from '../../components/common/modal';
import ShareThis from '../../components/common/share-this';

import CategoryFilterDrawer from '../../components/shop/controls/category-filter-drawer';
import GridHeader from '../../components/common/grid-header';
import ProductList from '../../components/shop/views/product-list';
import ProductViewBreadcrumbs from '../../components/shop/controls/product-view-breadcrumbs';

import PrintShopView from '../../components/shop/views/print-shop-view';
import ShirtShopView from '../../components/shop/views/shirt-shop-view';
import SimpleShopView from '../../components/shop/views/simple-shop-view';

import PrintShippingInfo from "../../components/shop/controls/PrintShippingInfo";
import PrintDetailsInfo from "../../components/shop/controls/PrintDetailsInfo";

import PrintsSpecialServicesBanner from "../../components/shop/views/prints-special-services-banner";

import '../../styles/shop/product-view.scss';
import TestimonialsCarousel from "../../components/shop/testimonials-carousel"

const strippedDescription = (data) => {
	if (data.product.data.Share_Description && data.product.data.Share_Description.length > 0) {
		return data.product.data.Share_Description;
	}

	if (data.product.data.Description) {
		let description = data.product.data.Description;

		description = description.replace('</div>', '');
		description = description.replace(/<div[\S\s]+?>/, '');

		return description;
	}

	return '';
};


export const Head = ({ data }) => {
	const titleString = `${data.product.data.Name.replace(/<span[\S\s]+?>/g,'').replace('</span>','')} – Product`;
	
	return (
		<HeadWrapper
			title={titleString}
		>
			<body className="has-share-buttons" />
			<meta
				id="metaTitle"
				name="title"
				content={titleString}
			/>
			<meta
				id="ogTitle"
				property="og:title"
				content={titleString}
			/>
			<meta
				id="metaDescription"
				name="description"
				content={strippedDescription(data)}
			/>
			<meta
				id="ogDescription"
				property="og:description"
				content={strippedDescription(data)}
			/>
			<meta
				id="ogImage"
				property="og:image"
				content={data.site.siteMetadata.imageHost + data.product.data.Image_File_Path}
			/>
			<meta
				id="ogUrl"
				property="og:url"
				content={`${data.site.siteMetadata.host}/product/${data.product.data.Reference}/`}
			/>
		</HeadWrapper>
	);
};

class ProductView extends React.Component {
	constructor(props) {
		super(props);

		const additionalImages = (props.data.product.data.Gallery_Image_Paths) ?
			props.data.product.data.Gallery_Image_Paths.split('\n') :
			[];

		this.state = {
			lightboxOpen: false,
			lightboxIndex: 0,
			lightboxContents: [
				props.data.product.data.Image_File_Path,
				...additionalImages,
			],
			modalOpen: false,
			modalContent: null,
			showAboutText: true,
			showDetailsText: false,
			showShippingText: false,
			loading: true,
			cartCurrency: null,
			filtersOpen: false,
			themedSetsOpen: false,
			searchOpen: false,
			aboutOpen: false,
		};

		this.checkForSnipcart();

		this.formattedPrice = this.formattedPrice.bind(this);
		this.onMultiCurrencyChange = this.onMultiCurrencyChange.bind(this);
		this.productCategory = this.productCategory.bind(this);
		this.productShopView = this.productShopView.bind(this);
		this.serializedPrices = this.serializedPrices.bind(this);
		this.shippingMessage = this.shippingMessage.bind(this);
		this.showLightbox = this.showLightbox.bind(this);
		this.showModalWithContent = this.showModalWithContent.bind(this);
		this.toggleFilterDrawers = this.toggleFilterDrawers.bind(this);
	}

	checkForSnipcart() {
		if (typeof window !== 'undefined' && window.Snipcart) {
			window.Snipcart.events.on('snipcart.initialized', (snipcartState) => {
				console.log('snipcart initialized');

				if (this.state.cartCurrency !== snipcartState.currency) {
					if (snipcartState.currency) {
						this.setState({ cartCurrency: snipcartState.currency });
					} else {
						this.setState({ cartCurrency: 'usd' });
					}
				}
			});
		}
	}

	componentDidMount() {
		if (typeof window !== 'undefined' && window.Snipcart) {
			const cart = window.Snipcart.store.getState().cart;

			if (this.state.cartCurrency !== cart.currency) {
				this.setState(
					{ cartCurrency: cart.currency },
					() => {
						this.setState({ loading: false });
					}
				);
			} else {
				this.setState({ loading: false});
			}
		}
	}

	onMultiCurrencyChange(ref) {
		window.Snipcart.api.session.setCurrency(ref);

		this.setState({ cartCurrency: ref });
	}

	productCategory() {
		switch (this.props.data.product.table) {
			case 'Simple':
				return this.props.data.product.data.Category;
			case 'Shirts':
				return 'Shirts';
			case 'Prints':
				return 'Prints';
			default:
				return null;
		}
	}

	productShopView() {
		switch (this.productCategory()) {
			case 'Prints':
				return (<PrintShopView
					data={this.props.data.product.data}
					onMultiCurrencyChange={this.onMultiCurrencyChange}
					formattedPrice={this.formattedPrice}
					serializedPrices={this.serializedPrices}
					shippingMessage={this.shippingMessage()}
					detailsMessage={this.detailsMessage()}
					showLightbox={this.showLightbox}
					showModalWithContent={this.showModalWithContent}
					cartCurrency={this.state.cartCurrency}
					loading={this.state.loading}
				/>);
			case 'Shirts':
				return (<ShirtShopView
					data={this.props.data.product.data}
					onMultiCurrencyChange={this.onMultiCurrencyChange}
					formattedPrice={this.formattedPrice}
					serializedPrices={this.serializedPrices}
					shippingMessage={this.shippingMessage()}
					detailsMessage={this.detailsMessage()}
					showLightbox={this.showLightbox}
					showModalWithContent={this.showModalWithContent}
					cartCurrency={this.state.cartCurrency}
					loading={this.state.loading}
				/>);
			default:
				return (<SimpleShopView
					data={this.props.data.product.data}
					onMultiCurrencyChange={this.onMultiCurrencyChange}
					formattedPrice={this.formattedPrice}
					serializedPrices={this.serializedPrices}
					productCategory={this.productCategory()}
					shippingMessage={this.shippingMessage()}
					showLightbox={this.showLightbox}
					showModalWithContent={this.showModalWithContent}
					cartCurrency={this.state.cartCurrency}
					loading={this.state.loading}
				/>);
		}
	}

	detailsMessage() {
		let reference = null;

		switch (this.productCategory()) {
			case 'Shirts':
				reference = 'shirt-details';
				break;
			default:
				reference = null;
		}

		if (reference) {
			if (reference) {
				return this.props.data.messages.edges.filter(({ node }) => node.data['Reference'] === reference)[0].node.data['Content'];
			}
		}

		return null;
	}

	formattedPrice(calculatedPrice) {
		if (!calculatedPrice) {
			return null;
		}

		const priceNumber = String(calculatedPrice.toFixed(2)).replace('.00', '');

		if (typeof window !== 'undefined' && window.Snipcart) {
			const cart = window.Snipcart.store.getState().cart;

			switch (cart.currency) {
				case 'usd':
					return `$${priceNumber}`;
				case 'gbp':
					return `£${priceNumber}`;
				case 'aud':
					return `AU$${priceNumber}`;
				case 'cad':
					return `Can$${priceNumber}`;
				case 'eur':
					return `€${priceNumber}`;
				default:
					return `$${priceNumber}`;
			}
		}

		return `$${priceNumber}`;
	}

	showLightbox(idx) {
		this.setState({
			lightboxIndex: idx,
			lightboxOpen: true,
		});
	}

	serializedPrices(calculatedPrice) {
		return JSON.stringify(calculatedPrice);
	}

	shippingMessage() {
		let reference = null;

		switch (this.productCategory()) {
			case 'Shirts':
				reference = 'shirt-shipping';
				break;
			case 'Totes':
				reference = 'self-shipping';
				break;
			case 'Books':
				reference = 'book-shipping';
				break;
			case 'Mugs':
				reference = 'mug-shipping';
				break;
			default:
				reference = null;
		}

		if (reference) {
			return this.props.data.messages.edges.filter(({ node }) => node.data['Reference'] === reference)[0].node.data['Content'];
		}

		return null;
	}

	showModalWithContent(content) {
		this.setState({
			modalOpen: true,
			modalContent: content,
		});
	}

	toggleFilterDrawers(drawer) {
		if (drawer === 'filters') {
			if (this.state.filtersOpen) {
				this.setState({ filtersOpen: false });
			} else {
				this.setState({ filtersOpen: true, themedSetsOpen: false, searchOpen: false, aboutOpen: false });
			}
		} else if (drawer === 'themedSets') {
			if (this.state.themedSetsOpen) {
				this.setState({ themedSetsOpen: false });
			} else {
				this.setState({ themedSetsOpen: true, filtersOpen: false, searchOpen: false, aboutOpen: false });
			}
		} else if (drawer === 'search') {
			if (this.state.searchOpen) {
				this.setState({ searchOpen: false });
			} else {
				this.setState({ searchOpen: true, themedSetsOpen: false, filtersOpen: false, aboutOpen: false });
			}
		} else if (drawer === 'about') {
			if (this.state.aboutOpen) {
				this.setState({ aboutOpen: false });
			} else {
				this.setState({ aboutOpen: true, searchOpen: false, filtersOpen: false, themedSetsOpen: false });
			}
		}
	}

	render() {
		const imageHost = this.props.data.site.siteMetadata.imageHost;
		const { lightboxIndex, lightboxContents } = this.state;

		return (
			<BaseLayout path={this.props.location.pathname}>
				<ShareThis
					variant="sticky"
					url={`${this.props.data.site.siteMetadata.host}/product/${this.props.data.product.data.Reference}`}
					image={this.props.data.site.siteMetadata.imageHost + this.props.data.product.data.Image_File_Path}
				/>
				{this.productCategory() === 'Prints' && (
					<div className="page-width">
						<CategoryFilterDrawer
							categorySlug='fine-art-prints'
							searchExpansionFlag={ this.state.searchOpen }
							searchToggle={ () => this.toggleFilterDrawers('search') }
							filtersExpansionFlag={ this.state.filtersOpen }
							filtersToggle={ () => this.toggleFilterDrawers('filters') }
							themedSetsExpansionFlag={ this.state.themedSetsOpen }
							themedSetsToggle={ () => this.toggleFilterDrawers('themedSets') }
							aboutExpansionFlag={ this.state.aboutOpen }
							aboutToggle={ () => this.toggleFilterDrawers('about') }
							pagePosition="top"
							themedSets={ this.props.data.themedSets }
							addTopMargin={ true }
							suppressSortTab= { true }
						/>
					</div>
				)}
				<div className="page-width">
					<ProductViewBreadcrumbs
						productCategory={this.productCategory()}
						productData={this.props.data.product.data}
						addTopMargin={ this.productCategory() !== 'Prints' }
					/>
				</div>
				<div className="page-width">
					{this.productShopView()}
				</div>

				{this.productCategory() === 'Prints' && (
					<div className="page-width section-spaced-row">
						<TestimonialsCarousel />
					</div>
				)}

				<div className="narrow-page-width section-spaced-row">
					<div className="product-texts">
						<div className="product-texts__tabs">
							{(this.props.data.product.data.Description && this.props.data.product.data.Description.length > 0) ? (
								<button
									className={`product-texts__tab ${this.state.showAboutText ? 'selected' : ''}`}
									onClick={() => {
										this.setState({
											showAboutText: true,
											showDetailsText: false,
											showShippingText: false,
										})
									}}
								>
									About
								</button>
							) : null}
							{(this.productCategory() === 'Prints' || (this.detailsMessage() && this.detailsMessage().length > 0)) ? (
								<button
									className={`product-texts__tab ${this.state.showDetailsText ? 'selected' : ''}`}
									onClick={() => {
										this.setState({
											showAboutText: false,
											showDetailsText: true,
											showShippingText: false,
										})
									}}
								>
									Details
								</button>
							) : null}
							{(this.productCategory() === 'Prints' || (this.shippingMessage() && this.shippingMessage().length > 0)) ? (
								<button
									className={`product-texts__tab ${this.state.showShippingText ? 'selected' : ''}`}
									onClick={() => {
										this.setState({
											showAboutText: false,
											showDetailsText: false,
											showShippingText: true,
										})
									}}
								>
									Shipping
								</button>
							) : null}
						</div>
						<div className="product-texts__panels">
							{(this.state.showAboutText && this.props.data.product.data.Description) ? (
								<div
									className="product-view__text-block"
									dangerouslySetInnerHTML={{ __html: marked(this.props.data.product.data.Description)}}
								/>
							) : null}
							{this.state.showDetailsText && (
								<>
									{this.detailsMessage() && (
										<div
											className="product-view__text-block"
											dangerouslySetInnerHTML={{__html: marked(this.detailsMessage())}}
										/>
									)}
									{this.productCategory() === "Prints" && (
										<PrintDetailsInfo />
									)}
								</>
							)}
							{this.state.showShippingText && (
								<>
									{this.shippingMessage() && (
										<div
											className="product-view__text-block"
											dangerouslySetInnerHTML={{ __html: marked(this.shippingMessage()) }}
										/>
									)}
									{this.productCategory() === "Prints" && (
										<PrintShippingInfo />
									)}
								</>
							)}
						</div>
					</div>
					<div className="product-view__share-buttons">
						<ShareThis
							variant="inline"
							url={`${this.props.data.site.siteMetadata.host}/product/${this.props.data.product.data.Reference}`}
							image={this.props.data.site.siteMetadata.imageHost + this.props.data.product.data.Image_File_Path}
						/>
					</div>
				</div>

				{this.productCategory() === 'Prints' && (
					<div className="page-width section-spaced-row">
						<PrintsSpecialServicesBanner />
					</div>
				)}

				<div className="page-width section-spaced-row">
					<GridHeader title="Related Products" />
					<ProductList products={this.props.pageContext.relatedProducts}
								 page={1}
								 perPage={8} />
				</div>

				{(this.state.lightboxOpen) ? (
					<Lightbox
						mainSrc={imageHost + lightboxContents[lightboxIndex]}
						nextSrc={(lightboxContents.length > 1) ? imageHost + lightboxContents[(lightboxIndex + 1) % lightboxContents.length] : null}
						prevSrc={(lightboxContents.length > 1) ? imageHost + lightboxContents[(lightboxIndex + lightboxContents.length - 1) % lightboxContents.length] : null}
						imagePadding={ 60 }
						reactModalStyle={ { overlay: { zIndex: 999999 } }}
						onCloseRequest={() => this.setState({ lightboxOpen: false })}
						onMovePrevRequest={() =>
							this.setState({
								lightboxIndex: (lightboxIndex + lightboxContents.length - 1) % lightboxContents.length,
							})
						}
						onMoveNextRequest={() =>
							this.setState({
								lightboxIndex: (lightboxIndex + 1) % lightboxContents.length,
							})
						}
					/>
				) : null}
				{(this.state.modalOpen) ? (
					<Modal
						content={ this.state.modalContent }
						closeModal={ () => this.setState({ modalOpen: false }) }
					/>
				) : null}
			</BaseLayout>
		)
	}
}

export default ProductView;

export const query = graphql`
fragment printAttributes on Airtable {
	data {
		Artist
		Year
		Style
		Century
		Place
		Subject
		Width__Small_
		Width__Medium_
		Width__Large_
		Width__X_Large_
		Height__Small_
		Height__Medium_
		Height__Large_
		Height__X_Large_
	}
}

query($reference: String!) {
	site {
		siteMetadata {
			host
			imageHost
		}
	}
	product: airtable(table: {in: ["Simple", "Prints", "Shirts"]}, data: {Reference: {eq: $reference}}) {
		...printAttributes
		table
		data {
			Name
			Reference
			Unavailable
			Category
			Colors
			Sizes
			Description
			Short_Description
			Share_Description
			Image_File_Path
			Gallery_Image_Paths
			Price_Profile {
				data {
					Name
					Conversions {
						data {
							Name
							USD
							GBP
							CAD
							AUD
							EUR
						}
					}
				}
			}
			Discount_Price_Profile {
				data {
					Name
					Conversions {
						data {
							Name
							USD
							GBP
							CAD
							AUD
							EUR
						}
					}
				}
			}
			Discount_Price_Tag
		}
	}
	messages: allAirtable(filter: {table: {eq: "Static Messages"}, data: {Category: {eq: "Shop"}}}) {
		edges {
			node {
				data {
					Reference
					Content
				}
			}
		}
	}
	themedSets:allAirtable(filter:{table:{eq:"Featured Print Themes"}, data:{Published:{eq:true}}}) {
		edges {
			node {
				data {
					Reference
					Name
					Image_Path
				}
			}
		}
	}
}
`;
